/*
 * @Author: liyxt
 * @Date: 2020-05-06 14:00:41
 * @LastEditors: bbqin
 * @LastEditTime: 2022-03-26 16:29:54
 * @Description: file content
 */
import React, { Component } from 'react';
import { Steps as OriginSteps } from "@tinper/next-ui";
const { Step } = OriginSteps;
require('./index.less');
export default class Steps extends Component {
   
    render() {
        const { steps, children } = this.props;
        return <OriginSteps {...this.props} >
            {Array.isArray(steps)
                ? steps.map(({ title, description }, index) => {
                    return <Step key={index} description={description} title={title}/>;
                })
                : children}
        </OriginSteps>;
    }
}
